<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="">Home</a></li>
      <li><a  href="">Transaction</a></li>
      <li><a class="active">{{ 'global.menu.unit' | translate }}</a></li>
    </ol>
  </div>
  <div class="col-md-12">
    <div class="col-md-4">
      &nbsp;
    </div>
    <div class="col-md-4 centertext">
      <h2 class="changePasswordHeading">{{ 'global.menu.unit' | translate }}</h2>
    </div>
    <div class="col-md-4">
      &nbsp;
    </div>
  </div>
  <div class="col-md-12  periodButtons borderButtnDiv">

      <p class="headerButnP" [ngClass]="[pickChosen == 1 ? 'activeButnA' : '']"><a class="customA" (click) ='getChartData("1WEEK")'>{{'transaction.button.last1week' | translate}}</a></p>

      <p class="headerButnP" [ngClass]="[pickChosen == 2 ? 'activeButnA' : '']"><a class="customA" (click) ='getChartData("1MONTH")'>{{'transaction.button.last1month' | translate}}</a></p>

      <p class="headerButnP" [ngClass]="[pickChosen == 3 ? 'activeButnA' : '']"><a class="customA"  (click) ='getChartData("3MONTHS")'>{{'transaction.button.last3month' | translate}}</a></p>

      <p class="headerButnP" [ngClass]="[pickChosen == 4 ? 'activeButnA' : '']"><a class="customA" (click) ='getChartData("6MONTHS")'>{{'transaction.button.last6month' | translate}}</a></p>
      <p class="headerButnP" [ngClass]="[pickChosen == 5 ? 'activeButnA' : 'headerButnA']"><a  class="customA" (click) ='getChartData("1YEAR")'>{{'transaction.button.last1year' | translate}}</a></p>
  </div>
  <form class="form-horizontal" [formGroup]="customFundForm" novalidate (submit)="requestPerformance()">
    <div class="col-md-12 marginCalendarDivTop noBottomMargin" >
      <div class="col-md-12" *ngIf="hideSearchString">
        <div class="col-md-4">
          &nbsp;
        </div>
        <div class="col-md-4">
          <input type="text" formControlName="searchString" autofocus="off" (keyup)="updateLabelStyle()" autofocus>
          <span class="bar"></span>
          <label [ngClass]="[updateStyle ? 'customLabel' : '']">{{'fund.search' | translate}}</label>
        </div>
        <div class="col-md-4">
          &nbsp;
        </div>
      </div>
    </div>
    <div class="col-md-12 calendarDiv" *ngIf="hideSearchString">
      <div class="col-md-2">
        &nbsp;
      </div>
      <div class="col-md-3">
        <button type="button" class="btn btn-outline clearButn btnbalance" (click)="clearSearchData()">Clear</button>
      </div>
      <div class="col-md-2">
        &nbsp;
      </div>
      <div class="col-md-3">
        <button type="submit" class="btn btn-primary btnbalance" [disabled]="!customFundForm.valid || buttonDisabled">{{'document.search' | translate}}</button>
      </div>
      <div class="col-md-2">
        &nbsp;
      </div>
    </div>
  </form>
<!--  <div class="col-md-12" *ngIf="invalidDateRange">
    <div class="alert alert-danger customMargin">Invalid Date Range</div>
  </div>-->
  <div class="col-md-12" *ngIf="inMaintenance">
    <div class="alert alert-info centerTextValue" >
      <h5 class="alert-headline centerTextValue">
        <span class="glyphicon glyphicon-exclamation-sign"></span>
        <span ></span>
      </h5>
      <p>{{'transaction.messages.unitprice.info.maintenance' | translate}}</p>
    </div>
  </div>
  <div class="col-md-12  mainFundPerformDiv" [ngSwitch]="progressIndicator">
       <span *ngSwitchCase="'loaded'">
            <div class="col-md-12 noBottomMargin" >
                <div class="col-md-4">
                  &nbsp;
                </div>
                <div class="col-md-4 centertext">
                  <button type="button"
                          class="btn btn-primary btnbalance" (click)="exportToPdf()">
                    <span class="glyphicon glyphicon-file-pdf"></span>&nbsp; Print Report
                  </button>
                </div>
                <div class="col-md-4">
                  &nbsp;
                </div>
            </div>
            <div class="col-md-12" >
                <div class="col-md-4">
                  &nbsp;
                </div>
                <div class="col-md-4 centertext">
                  From {{labelPeriodStart}} To {{labelPeriodEnd}}
                </div>
                <div class="col-md-4">
                  &nbsp;
                </div>
            </div>
				    <div id="charts" *ngFor="let chart of charts;let i = index;">
				        <div class="col-md-6" >
                  <h4 class="centertext" id="{{ 'chart-label-' + i }}" title="{{chart.title}}" tooltip-placement="left" >{{chart.title}}</h4>
				            <canvas  id="{{ 'chart-data-' + i }}" baseChart
                            [data]="chart.data"
                            [labels]="chart.labels"
                            [options]="lineChartOptions"
                            [colors]="lineChartColors"
                            [legend]="lineChartLegend"
                            [chartType]="lineChartType"
                            (chartHover)="chartHovered($event)"></canvas>
				        </div>
				    </div>
				</span>
				<span *ngSwitchCase="'timeout'">
					<div class="col-md-12 noBottomMargin alert alert-info centerTextValue">{{'global.messages.info.timeout' | translate}}</div>
				</span>
        <span *ngSwitchCase="'loading'">
        <img class="loader" src="assets/images/loading.gif"/>
      </span>
      <span *ngSwitchCase="'nodata'">
        <div class="col-md-12 noBottomMargin alert alert-info centerTextValue">{{'global.messages.info.nodata' | translate}}</div>
      </span>
      <span *ngSwitchDefault><div class="col-md-12 noBottomMargin alert alert-info centerTextValue">{{'global.messages.info.nodata' | translate}}</div></span>
  </div>
</div>
